import React from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import { Button, Card } from '@blueprintjs/core'
import { getContactById, importContact } from 'src/store/modules/cmdb/contacts'

class ContactCard extends React.Component {
    handleCheckClick = (contact) => () => {
        // this.props.toggleContactForImport(contact.id)
    }

    handleImportClick = () => {
        this.props.importContact(this.props.contact.id)
    }

    shouldComponentUpdate(nextProps) {
        return true
        // const selectedChanged = this.props.selected !== nextProps.selected
        // return selectedChanged
    }

    render() {
        const { contact, exists } = this.props
        return (
            <Card className="contact-card" interactive elevation={2}>
                <Flex w={1}>
                    <Box>
                        <h3 className="contact-card-heading">
                            {contact.fullName}
                        </h3>
                    </Box>
                    {/* <Box ml="auto">
                    <Checkbox onChange={this.handleCheckClick(contact)} checked={selected || false}/>
                </Box> */}
                </Flex>
                <p>{contact.userName}</p>
                <p>{contact.email}</p>
                <p>
                    <Button
                        text={exists ? 'Sync' : 'Import'}
                        onClick={this.handleImportClick}
                    />
                </p>
            </Card>
        )
    }
}

export default connect(
    (state, ownProps) => {
        const contact = getContactById(state, ownProps.contact)
        return {
            contact,
            exists: contact.exists,
            selected: contact.selected,
        }
    },
    { importContact }
)(ContactCard)
